// extracted by mini-css-extract-plugin
module.exports = {"mbs3":"Index_mbs3_2WNGi"};